"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _SystemIcons = require("../SystemIcons");

var _core = require("@emotion/core");

const SvgPower = props => {
  return (0, _core.jsx)(_SystemIcons.SystemIcons, props, (0, _core.jsx)("path", {
    d: "M19.337 17.933a1 1 0 010 1.414 8 8 0 1011.316 0 1 1 0 111.414-1.414c3.905 3.906 3.904 10.237-.001 14.141-3.905 3.905-10.237 3.905-14.142 0-3.905-3.904-3.906-10.235-.001-14.141a1 1 0 011.414 0zM25 13a1 1 0 011 1v10a1 1 0 01-2 0V14a1 1 0 011-1z",
    id: "power_svg__a"
  }));
};

var _default = SvgPower;
exports.default = _default;